import { CrystalProvider } from '@applyboard/crystal-ui'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ProtectedRoute } from './components/ProtectedRoute'
import {
  ApplicationsListPage,
  CreateApplicationPage,
  LoginPage,
  NotFoundPage,
  ViewApplicationPage,
} from './pages'
import initializers from './config/initializers'
import { HelmetProvider, Helmet } from 'react-helmet-async'
import { SignUpConfirmationPage } from './pages/SignUpConfirmationPage'
import { ConfigProvider } from './utils/ConfigProvider'
import { LoginCallback } from '@okta/okta-react'
import { ErrorElement } from './pages/ErrorPage'
import { ErrorBoundaryWrapper } from './components/ErrorBoundary'
import { MonitorProvider } from './hooks'

initializers.init()
const queryClient = new QueryClient()

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <script src="https://payment.flywire.com/assets/js/checkout.js"></script>
      </Helmet>
      <QueryClientProvider client={queryClient}>
        <CrystalProvider>
          <ConfigProvider>
            <MonitorProvider>
              <ErrorBoundaryWrapper>
                <BrowserRouter>
                  <Routes>
                    <Route
                      element={<ProtectedRoute />}
                      errorElement={<ErrorElement />}
                    >
                      <Route
                        path="/"
                        element={<ApplicationsListPage />}
                        errorElement={<ErrorElement />}
                      />
                      <Route
                        path="/applications/new"
                        element={<CreateApplicationPage />}
                        errorElement={<ErrorElement />}
                      />
                      <Route
                        path="/applications/:id"
                        element={<ViewApplicationPage />}
                        errorElement={<ErrorElement />}
                      />
                    </Route>
                    <Route
                      element={<ProtectedRoute isSignupLoginRoute />}
                      errorElement={<ErrorElement />}
                    >
                      <Route
                        path="/login"
                        element={<LoginPage />}
                        errorElement={<ErrorElement />}
                      />
                      <Route
                        path="/signup/:username/confirm"
                        element={<SignUpConfirmationPage />}
                        errorElement={<ErrorElement />}
                      />
                    </Route>
                    <Route
                      path="/login/callback"
                      element={<LoginCallback />}
                      errorElement={<ErrorElement />}
                    />
                    <Route
                      path="*"
                      element={<NotFoundPage />}
                      errorElement={<ErrorElement />}
                    />
                  </Routes>
                </BrowserRouter>
              </ErrorBoundaryWrapper>
            </MonitorProvider>
          </ConfigProvider>
        </CrystalProvider>
      </QueryClientProvider>
    </HelmetProvider>
  )
}

export default App
